import { Button as InternalButton } from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Button = {
  [DS_VERSIONS.default]: InternalButton,
}

export default Button[CURRENT_DS_VERSION]
